export const formatCoinCount = (count: number): string => {
  return `${count} COIN${count !== 1 ? 'S' : ''}`;
};

export const formatMultiplier = (value: string): string => {
  return value;
};